import { typeCreatorV2 } from '../../../redux/utils/common';

//  [REDUCER][TYPE]
export const SET_VATRETURN_LIST: string = typeCreatorV2(
  'VatReturnListReducer',
  'SetVatReturnList'
);

export const SET_VATRETURN_LIST_ALL: string = typeCreatorV2(
  'VatReturnListReducer',
  'SetVatReturnListAll'
);

export const SET_SCHEME_TYPES: string = typeCreatorV2(
  'VatReturnListReducer',
  'SetSchemeTypes'
);

export const SET_QUARTER_TYPES: string = typeCreatorV2(
  'VatReturnListReducer',
  'SetQuarterTypes'
);

export const SET_MONTH_QUARTER_TYPES: string = typeCreatorV2(
  'VatReturnListReducer',
  'SetMonthQuarterTypes'
);

export const ADD_VATRETURN: string = typeCreatorV2(
  'VatReturnListReducer',
  'AddVatReturn'
);

export const SET_USER_INFO_VAT_RETURN_CREATION: string = typeCreatorV2(
  'VatReturnListReducer',
  'SetUserInfoVatReturnCreation'
);

export const ADD_VAT_RETURN_PAYMENT: string = typeCreatorV2(
  'VatReturnListReducer',
  'AddVatReturnPayment'
);

export const SET_AGENT_TRADERS: string = typeCreatorV2(
  'VatReturnListReducer',
  'SetAgentTraders'
);
